/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type ModelAgendaCompanyFilterInput = {
  account_type?: ModelStringInput | null,
  address?: ModelStringInput | null,
  and?: Array< ModelAgendaCompanyFilterInput | null > | null,
  comId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  customer_id?: ModelStringInput | null,
  id?: ModelIDInput | null,
  image?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelAgendaCompanyFilterInput | null,
  or?: Array< ModelAgendaCompanyFilterInput | null > | null,
  phoneNumber?: ModelStringInput | null,
  planId?: ModelStringInput | null,
  subscriptionId?: ModelStringInput | null,
  suspended?: ModelBooleanInput | null,
  type?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type ModelStringInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  _null = "_null",
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
}


export type ModelSizeInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type ModelIDInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  size?: ModelSizeInput | null,
};

export type ModelBooleanInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  eq?: boolean | null,
  ne?: boolean | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelAgendaCompanyConnection = {
  __typename: "ModelAgendaCompanyConnection",
  items:  Array<AgendaCompany | null >,
  nextToken?: string | null,
};

export type AgendaCompany = {
  __typename: "AgendaCompany",
  account_type?: string | null,
  address?: string | null,
  comId: string,
  createdAt?: string | null,
  customer_id?: string | null,
  image?: string | null,
  name?: string | null,
  phoneNumber?: string | null,
  planId?: string | null,
  posts?: ModelAgendaPostConnection | null,
  subscriptionId?: string | null,
  suspended?: boolean | null,
  type?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
  users?: ModelAgendaUserConnection | null,
};

export type ModelAgendaPostConnection = {
  __typename: "ModelAgendaPostConnection",
  items:  Array<AgendaPost | null >,
  nextToken?: string | null,
};

export type AgendaPost = {
  __typename: "AgendaPost",
  com?: AgendaCompany | null,
  comId: string,
  createdAt?: string | null,
  deleted?: boolean | null,
  description?: string | null,
  image?: string | null,
  postId: string,
  room?: string | null,
  updatedAt?: string | null,
  user?: AgendaUser | null,
  userId?: string | null,
  username?: string | null,
};

export type AgendaUser = {
  __typename: "AgendaUser",
  FCMtoken?: string | null,
  com?: AgendaCompany | null,
  comId?: string | null,
  createdAt?: string | null,
  docs?: ModelAgendaDocumentConnection | null,
  email?: string | null,
  firstName?: string | null,
  friday?: boolean | null,
  honors?: ModelAgendaHonorConnection | null,
  hours?: number | null,
  image?: string | null,
  isConfirmed?: boolean | null,
  language?: string | null,
  lastName?: string | null,
  monday?: boolean | null,
  night?: boolean | null,
  password?: string | null,
  phoneNumber?: string | null,
  posts?: ModelAgendaPostConnection | null,
  profileOwner?: string | null,
  punches?: ModelAgendaPunchConnection | null,
  readedAt?: string | null,
  requests?: ModelAgendaRequestConnection | null,
  role?: string | null,
  saturday?: boolean | null,
  shiftApps?: ModelAgendaShiftApplicationConnection | null,
  shifts?: ModelAgendaShiftConnection | null,
  sunday?: boolean | null,
  suspended?: boolean | null,
  thursday?: boolean | null,
  timezone?: string | null,
  tuesday?: boolean | null,
  type?: AgendaUserType | null,
  updatedAt?: string | null,
  userId: string,
  username?: string | null,
  wednesday?: boolean | null,
};

export type ModelAgendaDocumentConnection = {
  __typename: "ModelAgendaDocumentConnection",
  items:  Array<AgendaDocument | null >,
  nextToken?: string | null,
};

export type AgendaDocument = {
  __typename: "AgendaDocument",
  comId?: string | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  docId: string,
  name?: string | null,
  path?: string | null,
  type?: string | null,
  updatedAt?: string | null,
  user?: AgendaUser | null,
  userId?: string | null,
};

export type ModelAgendaHonorConnection = {
  __typename: "ModelAgendaHonorConnection",
  items:  Array<AgendaHonor | null >,
  nextToken?: string | null,
};

export type AgendaHonor = {
  __typename: "AgendaHonor",
  createdAt?: string | null,
  deleted?: boolean | null,
  honorId: string,
  shift?: AgendaShift | null,
  shiftId: string,
  type?: AgendaHonorType | null,
  updatedAt?: string | null,
  user?: AgendaUser | null,
  userId: string,
};

export type AgendaShift = {
  __typename: "AgendaShift",
  accepted?: boolean | null,
  comId?: string | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  honors?: ModelAgendaHonorConnection | null,
  info?: string | null,
  lat?: string | null,
  lng?: string | null,
  location?: string | null,
  performance?: string | null,
  punch?: ModelAgendaPunchConnection | null,
  punctuality?: string | null,
  quality?: string | null,
  rate?: string | null,
  requests?: ModelAgendaRequestConnection | null,
  role?: string | null,
  shiftApp?: AgendaShiftApplication | null,
  shiftAppId?: string | null,
  shiftId: string,
  startAt?: string | null,
  stopAt?: string | null,
  suspended?: boolean | null,
  updatedAt?: string | null,
  user?: AgendaUser | null,
  userId?: string | null,
  username?: string | null,
};

export type ModelAgendaPunchConnection = {
  __typename: "ModelAgendaPunchConnection",
  items:  Array<AgendaPunch | null >,
  nextToken?: string | null,
};

export type AgendaPunch = {
  __typename: "AgendaPunch",
  accuracy?: string | null,
  altitude?: string | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  heading?: string | null,
  latitude?: string | null,
  longitude?: string | null,
  punchId: string,
  shift?: AgendaShift | null,
  shiftId?: string | null,
  speed?: string | null,
  startAt?: string | null,
  stopAt?: string | null,
  timestamp?: string | null,
  updatedAt?: string | null,
  user?: AgendaUser | null,
  userId?: string | null,
};

export type ModelAgendaRequestConnection = {
  __typename: "ModelAgendaRequestConnection",
  items:  Array<AgendaRequest | null >,
  nextToken?: string | null,
};

export type AgendaRequest = {
  __typename: "AgendaRequest",
  accepted?: boolean | null,
  comId?: string | null,
  completed?: boolean | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  description?: string | null,
  requestId: string,
  shift?: AgendaShift | null,
  shiftId?: string | null,
  startAt?: string | null,
  stopAt?: string | null,
  suggestedUser?: string | null,
  suggestedUserImage?: string | null,
  suggestedUserUsername?: string | null,
  type?: string | null,
  updatedAt?: string | null,
  user?: AgendaUser | null,
  userId?: string | null,
};

export type AgendaShiftApplication = {
  __typename: "AgendaShiftApplication",
  accepted?: boolean | null,
  comId?: string | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  info?: string | null,
  lat?: string | null,
  lng?: string | null,
  location?: string | null,
  role?: string | null,
  shiftAppId: string,
  shifts?: ModelAgendaShiftConnection | null,
  startAt?: string | null,
  stopAt?: string | null,
  suspended?: boolean | null,
  updatedAt?: string | null,
  user?: AgendaUser | null,
  userId?: string | null,
  username?: string | null,
};

export type ModelAgendaShiftConnection = {
  __typename: "ModelAgendaShiftConnection",
  items:  Array<AgendaShift | null >,
  nextToken?: string | null,
};

export enum AgendaHonorType {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
}


export type ModelAgendaShiftApplicationConnection = {
  __typename: "ModelAgendaShiftApplicationConnection",
  items:  Array<AgendaShiftApplication | null >,
  nextToken?: string | null,
};

export enum AgendaUserType {
  A = "A",
  ADMIN = "ADMIN",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
  EMPLOYEE = "EMPLOYEE",
  F = "F",
  G = "G",
  H = "H",
  I = "I",
  J = "J",
  K = "K",
  L = "L",
  M = "M",
  MANAGER = "MANAGER",
  N = "N",
  O = "O",
  P = "P",
}


export type ModelAgendaUserConnection = {
  __typename: "ModelAgendaUserConnection",
  items:  Array<AgendaUser | null >,
  nextToken?: string | null,
};

export type ModelStringKeyConditionInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  le?: string | null,
  lt?: string | null,
};

export type ModelAgendaDocumentFilterInput = {
  and?: Array< ModelAgendaDocumentFilterInput | null > | null,
  comId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  docId?: ModelIDInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  not?: ModelAgendaDocumentFilterInput | null,
  or?: Array< ModelAgendaDocumentFilterInput | null > | null,
  path?: ModelStringInput | null,
  type?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelAgendaHonorFilterInput = {
  and?: Array< ModelAgendaHonorFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  honorId?: ModelIDInput | null,
  id?: ModelIDInput | null,
  not?: ModelAgendaHonorFilterInput | null,
  or?: Array< ModelAgendaHonorFilterInput | null > | null,
  shiftId?: ModelIDInput | null,
  type?: ModelAgendaHonorTypeInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelAgendaHonorTypeInput = {
  eq?: AgendaHonorType | null,
  ne?: AgendaHonorType | null,
};

export type ModelAgendaPostFilterInput = {
  and?: Array< ModelAgendaPostFilterInput | null > | null,
  comId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  image?: ModelStringInput | null,
  not?: ModelAgendaPostFilterInput | null,
  or?: Array< ModelAgendaPostFilterInput | null > | null,
  postId?: ModelIDInput | null,
  room?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  username?: ModelStringInput | null,
};

export type ModelAgendaPunchFilterInput = {
  accuracy?: ModelStringInput | null,
  altitude?: ModelStringInput | null,
  and?: Array< ModelAgendaPunchFilterInput | null > | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  heading?: ModelStringInput | null,
  id?: ModelIDInput | null,
  latitude?: ModelStringInput | null,
  longitude?: ModelStringInput | null,
  not?: ModelAgendaPunchFilterInput | null,
  or?: Array< ModelAgendaPunchFilterInput | null > | null,
  punchId?: ModelIDInput | null,
  shiftId?: ModelIDInput | null,
  speed?: ModelStringInput | null,
  startAt?: ModelStringInput | null,
  stopAt?: ModelStringInput | null,
  timestamp?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelAgendaRequestFilterInput = {
  accepted?: ModelBooleanInput | null,
  and?: Array< ModelAgendaRequestFilterInput | null > | null,
  comId?: ModelIDInput | null,
  completed?: ModelBooleanInput | null,
  confirmed?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  id?: ModelIDInput | null,
  not?: ModelAgendaRequestFilterInput | null,
  or?: Array< ModelAgendaRequestFilterInput | null > | null,
  requestId?: ModelIDInput | null,
  shiftId?: ModelIDInput | null,
  startAt?: ModelStringInput | null,
  stopAt?: ModelStringInput | null,
  suggestedUser?: ModelStringInput | null,
  suggestedUserImage?: ModelStringInput | null,
  suggestedUserUsername?: ModelStringInput | null,
  type?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type ModelAgendaShiftApplicationFilterInput = {
  accepted?: ModelBooleanInput | null,
  and?: Array< ModelAgendaShiftApplicationFilterInput | null > | null,
  comId?: ModelIDInput | null,
  confirmed?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  id?: ModelIDInput | null,
  info?: ModelStringInput | null,
  lat?: ModelStringInput | null,
  lng?: ModelStringInput | null,
  location?: ModelStringInput | null,
  not?: ModelAgendaShiftApplicationFilterInput | null,
  or?: Array< ModelAgendaShiftApplicationFilterInput | null > | null,
  role?: ModelStringInput | null,
  shiftAppId?: ModelIDInput | null,
  startAt?: ModelStringInput | null,
  stopAt?: ModelStringInput | null,
  suspended?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  username?: ModelStringInput | null,
};

export type ModelAgendaShiftFilterInput = {
  accepted?: ModelBooleanInput | null,
  and?: Array< ModelAgendaShiftFilterInput | null > | null,
  comId?: ModelIDInput | null,
  confirmed?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  id?: ModelIDInput | null,
  info?: ModelStringInput | null,
  lat?: ModelStringInput | null,
  lng?: ModelStringInput | null,
  location?: ModelStringInput | null,
  not?: ModelAgendaShiftFilterInput | null,
  or?: Array< ModelAgendaShiftFilterInput | null > | null,
  performance?: ModelStringInput | null,
  punctuality?: ModelStringInput | null,
  quality?: ModelStringInput | null,
  rate?: ModelStringInput | null,
  role?: ModelStringInput | null,
  shiftAppId?: ModelIDInput | null,
  shiftId?: ModelIDInput | null,
  startAt?: ModelStringInput | null,
  stopAt?: ModelStringInput | null,
  suspended?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  username?: ModelStringInput | null,
};

export type ModelAgendaUserFilterInput = {
  FCMtoken?: ModelStringInput | null,
  and?: Array< ModelAgendaUserFilterInput | null > | null,
  comId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  friday?: ModelBooleanInput | null,
  hours?: ModelFloatInput | null,
  id?: ModelIDInput | null,
  image?: ModelStringInput | null,
  isConfirmed?: ModelBooleanInput | null,
  language?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  monday?: ModelBooleanInput | null,
  night?: ModelBooleanInput | null,
  not?: ModelAgendaUserFilterInput | null,
  or?: Array< ModelAgendaUserFilterInput | null > | null,
  password?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  profileOwner?: ModelStringInput | null,
  readedAt?: ModelStringInput | null,
  role?: ModelStringInput | null,
  saturday?: ModelBooleanInput | null,
  sunday?: ModelBooleanInput | null,
  suspended?: ModelBooleanInput | null,
  thursday?: ModelBooleanInput | null,
  timezone?: ModelStringInput | null,
  tuesday?: ModelBooleanInput | null,
  type?: ModelAgendaUserTypeInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  username?: ModelStringInput | null,
  wednesday?: ModelBooleanInput | null,
};

export type ModelFloatInput = {
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
};

export type ModelAgendaUserTypeInput = {
  eq?: AgendaUserType | null,
  ne?: AgendaUserType | null,
};

export type ModelAgendaCompanyConditionInput = {
  account_type?: ModelStringInput | null,
  address?: ModelStringInput | null,
  and?: Array< ModelAgendaCompanyConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  customer_id?: ModelStringInput | null,
  image?: ModelStringInput | null,
  name?: ModelStringInput | null,
  not?: ModelAgendaCompanyConditionInput | null,
  or?: Array< ModelAgendaCompanyConditionInput | null > | null,
  phoneNumber?: ModelStringInput | null,
  planId?: ModelStringInput | null,
  subscriptionId?: ModelStringInput | null,
  suspended?: ModelBooleanInput | null,
  type?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelStringInput | null,
};

export type CreateAgendaCompanyInput = {
  account_type?: string | null,
  address?: string | null,
  comId: string,
  createdAt?: string | null,
  customer_id?: string | null,
  image?: string | null,
  name?: string | null,
  phoneNumber?: string | null,
  planId?: string | null,
  subscriptionId?: string | null,
  suspended?: boolean | null,
  type?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type ModelAgendaDocumentConditionInput = {
  and?: Array< ModelAgendaDocumentConditionInput | null > | null,
  comId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  not?: ModelAgendaDocumentConditionInput | null,
  or?: Array< ModelAgendaDocumentConditionInput | null > | null,
  path?: ModelStringInput | null,
  type?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateAgendaDocumentInput = {
  comId?: string | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  docId: string,
  name?: string | null,
  path?: string | null,
  type?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type ModelAgendaHonorConditionInput = {
  and?: Array< ModelAgendaHonorConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  not?: ModelAgendaHonorConditionInput | null,
  or?: Array< ModelAgendaHonorConditionInput | null > | null,
  shiftId?: ModelIDInput | null,
  type?: ModelAgendaHonorTypeInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateAgendaHonorInput = {
  createdAt?: string | null,
  deleted?: boolean | null,
  honorId: string,
  shiftId: string,
  type?: AgendaHonorType | null,
  updatedAt?: string | null,
  userId: string,
};

export type ModelAgendaPostConditionInput = {
  and?: Array< ModelAgendaPostConditionInput | null > | null,
  comId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  image?: ModelStringInput | null,
  not?: ModelAgendaPostConditionInput | null,
  or?: Array< ModelAgendaPostConditionInput | null > | null,
  room?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  username?: ModelStringInput | null,
};

export type CreateAgendaPostInput = {
  comId: string,
  createdAt?: string | null,
  deleted?: boolean | null,
  description?: string | null,
  image?: string | null,
  postId: string,
  room?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
  username?: string | null,
};

export type ModelAgendaPunchConditionInput = {
  accuracy?: ModelStringInput | null,
  altitude?: ModelStringInput | null,
  and?: Array< ModelAgendaPunchConditionInput | null > | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  heading?: ModelStringInput | null,
  latitude?: ModelStringInput | null,
  longitude?: ModelStringInput | null,
  not?: ModelAgendaPunchConditionInput | null,
  or?: Array< ModelAgendaPunchConditionInput | null > | null,
  shiftId?: ModelIDInput | null,
  speed?: ModelStringInput | null,
  startAt?: ModelStringInput | null,
  stopAt?: ModelStringInput | null,
  timestamp?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateAgendaPunchInput = {
  accuracy?: string | null,
  altitude?: string | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  heading?: string | null,
  latitude?: string | null,
  longitude?: string | null,
  punchId: string,
  shiftId?: string | null,
  speed?: string | null,
  startAt?: string | null,
  stopAt?: string | null,
  timestamp?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type ModelAgendaRequestConditionInput = {
  accepted?: ModelBooleanInput | null,
  and?: Array< ModelAgendaRequestConditionInput | null > | null,
  comId?: ModelIDInput | null,
  completed?: ModelBooleanInput | null,
  confirmed?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  not?: ModelAgendaRequestConditionInput | null,
  or?: Array< ModelAgendaRequestConditionInput | null > | null,
  shiftId?: ModelIDInput | null,
  startAt?: ModelStringInput | null,
  stopAt?: ModelStringInput | null,
  suggestedUser?: ModelStringInput | null,
  suggestedUserImage?: ModelStringInput | null,
  suggestedUserUsername?: ModelStringInput | null,
  type?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
};

export type CreateAgendaRequestInput = {
  accepted?: boolean | null,
  comId?: string | null,
  completed?: boolean | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  description?: string | null,
  requestId: string,
  shiftId?: string | null,
  startAt?: string | null,
  stopAt?: string | null,
  suggestedUser?: string | null,
  suggestedUserImage?: string | null,
  suggestedUserUsername?: string | null,
  type?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type ModelAgendaShiftConditionInput = {
  accepted?: ModelBooleanInput | null,
  and?: Array< ModelAgendaShiftConditionInput | null > | null,
  comId?: ModelIDInput | null,
  confirmed?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  info?: ModelStringInput | null,
  lat?: ModelStringInput | null,
  lng?: ModelStringInput | null,
  location?: ModelStringInput | null,
  not?: ModelAgendaShiftConditionInput | null,
  or?: Array< ModelAgendaShiftConditionInput | null > | null,
  performance?: ModelStringInput | null,
  punctuality?: ModelStringInput | null,
  quality?: ModelStringInput | null,
  rate?: ModelStringInput | null,
  role?: ModelStringInput | null,
  shiftAppId?: ModelIDInput | null,
  startAt?: ModelStringInput | null,
  stopAt?: ModelStringInput | null,
  suspended?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  username?: ModelStringInput | null,
};

export type CreateAgendaShiftInput = {
  accepted?: boolean | null,
  comId?: string | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  info?: string | null,
  lat?: string | null,
  lng?: string | null,
  location?: string | null,
  performance?: string | null,
  punctuality?: string | null,
  quality?: string | null,
  rate?: string | null,
  role?: string | null,
  shiftAppId?: string | null,
  shiftId: string,
  startAt?: string | null,
  stopAt?: string | null,
  suspended?: boolean | null,
  updatedAt?: string | null,
  userId?: string | null,
  username?: string | null,
};

export type ModelAgendaShiftApplicationConditionInput = {
  accepted?: ModelBooleanInput | null,
  and?: Array< ModelAgendaShiftApplicationConditionInput | null > | null,
  comId?: ModelIDInput | null,
  confirmed?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  deleted?: ModelBooleanInput | null,
  info?: ModelStringInput | null,
  lat?: ModelStringInput | null,
  lng?: ModelStringInput | null,
  location?: ModelStringInput | null,
  not?: ModelAgendaShiftApplicationConditionInput | null,
  or?: Array< ModelAgendaShiftApplicationConditionInput | null > | null,
  role?: ModelStringInput | null,
  startAt?: ModelStringInput | null,
  stopAt?: ModelStringInput | null,
  suspended?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
  userId?: ModelIDInput | null,
  username?: ModelStringInput | null,
};

export type CreateAgendaShiftApplicationInput = {
  accepted?: boolean | null,
  comId?: string | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  info?: string | null,
  lat?: string | null,
  lng?: string | null,
  location?: string | null,
  role?: string | null,
  shiftAppId: string,
  startAt?: string | null,
  stopAt?: string | null,
  suspended?: boolean | null,
  updatedAt?: string | null,
  userId?: string | null,
  username?: string | null,
};

export type ModelAgendaUserConditionInput = {
  FCMtoken?: ModelStringInput | null,
  and?: Array< ModelAgendaUserConditionInput | null > | null,
  comId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  friday?: ModelBooleanInput | null,
  hours?: ModelFloatInput | null,
  image?: ModelStringInput | null,
  isConfirmed?: ModelBooleanInput | null,
  language?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  monday?: ModelBooleanInput | null,
  night?: ModelBooleanInput | null,
  not?: ModelAgendaUserConditionInput | null,
  or?: Array< ModelAgendaUserConditionInput | null > | null,
  password?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  profileOwner?: ModelStringInput | null,
  readedAt?: ModelStringInput | null,
  role?: ModelStringInput | null,
  saturday?: ModelBooleanInput | null,
  sunday?: ModelBooleanInput | null,
  suspended?: ModelBooleanInput | null,
  thursday?: ModelBooleanInput | null,
  timezone?: ModelStringInput | null,
  tuesday?: ModelBooleanInput | null,
  type?: ModelAgendaUserTypeInput | null,
  updatedAt?: ModelStringInput | null,
  username?: ModelStringInput | null,
  wednesday?: ModelBooleanInput | null,
};

export type CreateAgendaUserInput = {
  FCMtoken?: string | null,
  comId?: string | null,
  createdAt?: string | null,
  email?: string | null,
  firstName?: string | null,
  friday?: boolean | null,
  hours?: number | null,
  image?: string | null,
  isConfirmed?: boolean | null,
  language?: string | null,
  lastName?: string | null,
  monday?: boolean | null,
  night?: boolean | null,
  password?: string | null,
  phoneNumber?: string | null,
  profileOwner?: string | null,
  readedAt?: string | null,
  role?: string | null,
  saturday?: boolean | null,
  sunday?: boolean | null,
  suspended?: boolean | null,
  thursday?: boolean | null,
  timezone?: string | null,
  tuesday?: boolean | null,
  type?: AgendaUserType | null,
  updatedAt?: string | null,
  userId: string,
  username?: string | null,
  wednesday?: boolean | null,
};

export type DeleteAgendaCompanyInput = {
  comId: string,
};

export type DeleteAgendaDocumentInput = {
  docId: string,
};

export type DeleteAgendaHonorInput = {
  honorId: string,
};

export type DeleteAgendaPostInput = {
  postId: string,
};

export type DeleteAgendaPunchInput = {
  punchId: string,
};

export type DeleteAgendaRequestInput = {
  requestId: string,
};

export type DeleteAgendaShiftInput = {
  shiftId: string,
};

export type DeleteAgendaShiftApplicationInput = {
  shiftAppId: string,
};

export type DeleteAgendaUserInput = {
  userId: string,
};

export type UpdateAgendaCompanyInput = {
  account_type?: string | null,
  address?: string | null,
  comId: string,
  createdAt?: string | null,
  customer_id?: string | null,
  image?: string | null,
  name?: string | null,
  phoneNumber?: string | null,
  planId?: string | null,
  subscriptionId?: string | null,
  suspended?: boolean | null,
  type?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateAgendaDocumentInput = {
  comId?: string | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  docId: string,
  name?: string | null,
  path?: string | null,
  type?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateAgendaHonorInput = {
  createdAt?: string | null,
  deleted?: boolean | null,
  honorId: string,
  shiftId?: string | null,
  type?: AgendaHonorType | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateAgendaPostInput = {
  comId?: string | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  description?: string | null,
  image?: string | null,
  postId: string,
  room?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
  username?: string | null,
};

export type UpdateAgendaPunchInput = {
  accuracy?: string | null,
  altitude?: string | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  heading?: string | null,
  latitude?: string | null,
  longitude?: string | null,
  punchId: string,
  shiftId?: string | null,
  speed?: string | null,
  startAt?: string | null,
  stopAt?: string | null,
  timestamp?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateAgendaRequestInput = {
  accepted?: boolean | null,
  comId?: string | null,
  completed?: boolean | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  description?: string | null,
  requestId: string,
  shiftId?: string | null,
  startAt?: string | null,
  stopAt?: string | null,
  suggestedUser?: string | null,
  suggestedUserImage?: string | null,
  suggestedUserUsername?: string | null,
  type?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type UpdateAgendaShiftInput = {
  accepted?: boolean | null,
  comId?: string | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  info?: string | null,
  lat?: string | null,
  lng?: string | null,
  location?: string | null,
  performance?: string | null,
  punctuality?: string | null,
  quality?: string | null,
  rate?: string | null,
  role?: string | null,
  shiftAppId?: string | null,
  shiftId: string,
  startAt?: string | null,
  stopAt?: string | null,
  suspended?: boolean | null,
  updatedAt?: string | null,
  userId?: string | null,
  username?: string | null,
};

export type UpdateAgendaShiftApplicationInput = {
  accepted?: boolean | null,
  comId?: string | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  info?: string | null,
  lat?: string | null,
  lng?: string | null,
  location?: string | null,
  role?: string | null,
  shiftAppId: string,
  startAt?: string | null,
  stopAt?: string | null,
  suspended?: boolean | null,
  updatedAt?: string | null,
  userId?: string | null,
  username?: string | null,
};

export type UpdateAgendaUserInput = {
  FCMtoken?: string | null,
  comId?: string | null,
  createdAt?: string | null,
  email?: string | null,
  firstName?: string | null,
  friday?: boolean | null,
  hours?: number | null,
  image?: string | null,
  isConfirmed?: boolean | null,
  language?: string | null,
  lastName?: string | null,
  monday?: boolean | null,
  night?: boolean | null,
  password?: string | null,
  phoneNumber?: string | null,
  profileOwner?: string | null,
  readedAt?: string | null,
  role?: string | null,
  saturday?: boolean | null,
  sunday?: boolean | null,
  suspended?: boolean | null,
  thursday?: boolean | null,
  timezone?: string | null,
  tuesday?: boolean | null,
  type?: AgendaUserType | null,
  updatedAt?: string | null,
  userId: string,
  username?: string | null,
  wednesday?: boolean | null,
};

export type ModelSubscriptionAgendaCompanyFilterInput = {
  account_type?: ModelSubscriptionStringInput | null,
  address?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgendaCompanyFilterInput | null > | null,
  comId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  customer_id?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  image?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionAgendaCompanyFilterInput | null > | null,
  phoneNumber?: ModelSubscriptionStringInput | null,
  planId?: ModelSubscriptionStringInput | null,
  subscriptionId?: ModelSubscriptionStringInput | null,
  suspended?: ModelSubscriptionBooleanInput | null,
  type?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionStringInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  in?: Array< string | null > | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionIDInput = {
  beginsWith?: string | null,
  between?: Array< string | null > | null,
  contains?: string | null,
  eq?: string | null,
  ge?: string | null,
  gt?: string | null,
  in?: Array< string | null > | null,
  le?: string | null,
  lt?: string | null,
  ne?: string | null,
  notContains?: string | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  eq?: boolean | null,
  ne?: boolean | null,
};

export type ModelSubscriptionAgendaDocumentFilterInput = {
  and?: Array< ModelSubscriptionAgendaDocumentFilterInput | null > | null,
  comId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionBooleanInput | null,
  docId?: ModelSubscriptionIDInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionAgendaDocumentFilterInput | null > | null,
  path?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionAgendaHonorFilterInput = {
  and?: Array< ModelSubscriptionAgendaHonorFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionBooleanInput | null,
  honorId?: ModelSubscriptionIDInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionAgendaHonorFilterInput | null > | null,
  shiftId?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionAgendaPostFilterInput = {
  and?: Array< ModelSubscriptionAgendaPostFilterInput | null > | null,
  comId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionBooleanInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  image?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionAgendaPostFilterInput | null > | null,
  postId?: ModelSubscriptionIDInput | null,
  room?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
  username?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionAgendaPunchFilterInput = {
  accuracy?: ModelSubscriptionStringInput | null,
  altitude?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgendaPunchFilterInput | null > | null,
  createdAt?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionBooleanInput | null,
  heading?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  latitude?: ModelSubscriptionStringInput | null,
  longitude?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionAgendaPunchFilterInput | null > | null,
  punchId?: ModelSubscriptionIDInput | null,
  shiftId?: ModelSubscriptionIDInput | null,
  speed?: ModelSubscriptionStringInput | null,
  startAt?: ModelSubscriptionStringInput | null,
  stopAt?: ModelSubscriptionStringInput | null,
  timestamp?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionAgendaRequestFilterInput = {
  accepted?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionAgendaRequestFilterInput | null > | null,
  comId?: ModelSubscriptionIDInput | null,
  completed?: ModelSubscriptionBooleanInput | null,
  confirmed?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionBooleanInput | null,
  description?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  or?: Array< ModelSubscriptionAgendaRequestFilterInput | null > | null,
  requestId?: ModelSubscriptionIDInput | null,
  shiftId?: ModelSubscriptionIDInput | null,
  startAt?: ModelSubscriptionStringInput | null,
  stopAt?: ModelSubscriptionStringInput | null,
  suggestedUser?: ModelSubscriptionStringInput | null,
  suggestedUserImage?: ModelSubscriptionStringInput | null,
  suggestedUserUsername?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionAgendaShiftFilterInput = {
  accepted?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionAgendaShiftFilterInput | null > | null,
  comId?: ModelSubscriptionIDInput | null,
  confirmed?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionBooleanInput | null,
  id?: ModelSubscriptionIDInput | null,
  info?: ModelSubscriptionStringInput | null,
  lat?: ModelSubscriptionStringInput | null,
  lng?: ModelSubscriptionStringInput | null,
  location?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionAgendaShiftFilterInput | null > | null,
  performance?: ModelSubscriptionStringInput | null,
  punctuality?: ModelSubscriptionStringInput | null,
  quality?: ModelSubscriptionStringInput | null,
  rate?: ModelSubscriptionStringInput | null,
  role?: ModelSubscriptionStringInput | null,
  shiftAppId?: ModelSubscriptionIDInput | null,
  shiftId?: ModelSubscriptionIDInput | null,
  startAt?: ModelSubscriptionStringInput | null,
  stopAt?: ModelSubscriptionStringInput | null,
  suspended?: ModelSubscriptionBooleanInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
  username?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionAgendaShiftApplicationFilterInput = {
  accepted?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionAgendaShiftApplicationFilterInput | null > | null,
  comId?: ModelSubscriptionIDInput | null,
  confirmed?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionBooleanInput | null,
  id?: ModelSubscriptionIDInput | null,
  info?: ModelSubscriptionStringInput | null,
  lat?: ModelSubscriptionStringInput | null,
  lng?: ModelSubscriptionStringInput | null,
  location?: ModelSubscriptionStringInput | null,
  or?: Array< ModelSubscriptionAgendaShiftApplicationFilterInput | null > | null,
  role?: ModelSubscriptionStringInput | null,
  shiftAppId?: ModelSubscriptionIDInput | null,
  startAt?: ModelSubscriptionStringInput | null,
  stopAt?: ModelSubscriptionStringInput | null,
  suspended?: ModelSubscriptionBooleanInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
  username?: ModelSubscriptionStringInput | null,
};

export type ModelSubscriptionAgendaUserFilterInput = {
  FCMtoken?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAgendaUserFilterInput | null > | null,
  comId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  friday?: ModelSubscriptionBooleanInput | null,
  hours?: ModelSubscriptionFloatInput | null,
  id?: ModelSubscriptionIDInput | null,
  image?: ModelSubscriptionStringInput | null,
  isConfirmed?: ModelSubscriptionBooleanInput | null,
  language?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  monday?: ModelSubscriptionBooleanInput | null,
  night?: ModelSubscriptionBooleanInput | null,
  or?: Array< ModelSubscriptionAgendaUserFilterInput | null > | null,
  password?: ModelSubscriptionStringInput | null,
  phoneNumber?: ModelSubscriptionStringInput | null,
  profileOwner?: ModelSubscriptionStringInput | null,
  readedAt?: ModelSubscriptionStringInput | null,
  role?: ModelSubscriptionStringInput | null,
  saturday?: ModelSubscriptionBooleanInput | null,
  sunday?: ModelSubscriptionBooleanInput | null,
  suspended?: ModelSubscriptionBooleanInput | null,
  thursday?: ModelSubscriptionBooleanInput | null,
  timezone?: ModelSubscriptionStringInput | null,
  tuesday?: ModelSubscriptionBooleanInput | null,
  type?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionIDInput | null,
  username?: ModelSubscriptionStringInput | null,
  wednesday?: ModelSubscriptionBooleanInput | null,
};

export type ModelSubscriptionFloatInput = {
  between?: Array< number | null > | null,
  eq?: number | null,
  ge?: number | null,
  gt?: number | null,
  in?: Array< number | null > | null,
  le?: number | null,
  lt?: number | null,
  ne?: number | null,
  notIn?: Array< number | null > | null,
};

export type ComByUserIdQueryVariables = {
  filter?: ModelAgendaCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type ComByUserIdQuery = {
  comByUserId?:  {
    __typename: "ModelAgendaCompanyConnection",
    items:  Array< {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DocsByComQueryVariables = {
  comId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type DocsByComQuery = {
  docsByCom?:  {
    __typename: "ModelAgendaDocumentConnection",
    items:  Array< {
      __typename: "AgendaDocument",
      comId?: string | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      docId: string,
      name?: string | null,
      path?: string | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DocsByUserQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type DocsByUserQuery = {
  docsByUser?:  {
    __typename: "ModelAgendaDocumentConnection",
    items:  Array< {
      __typename: "AgendaDocument",
      comId?: string | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      docId: string,
      name?: string | null,
      path?: string | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAgendaCompanyQueryVariables = {
  comId: string,
};

export type GetAgendaCompanyQuery = {
  getAgendaCompany?:  {
    __typename: "AgendaCompany",
    account_type?: string | null,
    address?: string | null,
    comId: string,
    createdAt?: string | null,
    customer_id?: string | null,
    image?: string | null,
    name?: string | null,
    phoneNumber?: string | null,
    planId?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    subscriptionId?: string | null,
    suspended?: boolean | null,
    type?: string | null,
    updatedAt?: string | null,
    userId?: string | null,
    users?:  {
      __typename: "ModelAgendaUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type GetAgendaDocumentQueryVariables = {
  docId: string,
};

export type GetAgendaDocumentQuery = {
  getAgendaDocument?:  {
    __typename: "AgendaDocument",
    comId?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    docId: string,
    name?: string | null,
    path?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type GetAgendaHonorQueryVariables = {
  honorId: string,
};

export type GetAgendaHonorQuery = {
  getAgendaHonor?:  {
    __typename: "AgendaHonor",
    createdAt?: string | null,
    deleted?: boolean | null,
    honorId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId: string,
    type?: AgendaHonorType | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId: string,
  } | null,
};

export type GetAgendaPostQueryVariables = {
  postId: string,
};

export type GetAgendaPostQuery = {
  getAgendaPost?:  {
    __typename: "AgendaPost",
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId: string,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    image?: string | null,
    postId: string,
    room?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type GetAgendaPunchQueryVariables = {
  punchId: string,
};

export type GetAgendaPunchQuery = {
  getAgendaPunch?:  {
    __typename: "AgendaPunch",
    accuracy?: string | null,
    altitude?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    heading?: string | null,
    latitude?: string | null,
    longitude?: string | null,
    punchId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    speed?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    timestamp?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type GetAgendaRequestQueryVariables = {
  requestId: string,
};

export type GetAgendaRequestQuery = {
  getAgendaRequest?:  {
    __typename: "AgendaRequest",
    accepted?: boolean | null,
    comId?: string | null,
    completed?: boolean | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    requestId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    suggestedUser?: string | null,
    suggestedUserImage?: string | null,
    suggestedUserUsername?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type GetAgendaShiftQueryVariables = {
  shiftId: string,
};

export type GetAgendaShiftQuery = {
  getAgendaShift?:  {
    __typename: "AgendaShift",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    performance?: string | null,
    punch?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    punctuality?: string | null,
    quality?: string | null,
    rate?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    shiftApp?:  {
      __typename: "AgendaShiftApplication",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      role?: string | null,
      shiftAppId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftAppId?: string | null,
    shiftId: string,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type GetAgendaShiftApplicationQueryVariables = {
  shiftAppId: string,
};

export type GetAgendaShiftApplicationQuery = {
  getAgendaShiftApplication?:  {
    __typename: "AgendaShiftApplication",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    role?: string | null,
    shiftAppId: string,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type GetAgendaUserQueryVariables = {
  userId: string,
};

export type GetAgendaUserQuery = {
  getAgendaUser?:  {
    __typename: "AgendaUser",
    FCMtoken?: string | null,
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId?: string | null,
    createdAt?: string | null,
    docs?:  {
      __typename: "ModelAgendaDocumentConnection",
      nextToken?: string | null,
    } | null,
    email?: string | null,
    firstName?: string | null,
    friday?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    hours?: number | null,
    image?: string | null,
    isConfirmed?: boolean | null,
    language?: string | null,
    lastName?: string | null,
    monday?: boolean | null,
    night?: boolean | null,
    password?: string | null,
    phoneNumber?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    profileOwner?: string | null,
    punches?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    readedAt?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    saturday?: boolean | null,
    shiftApps?:  {
      __typename: "ModelAgendaShiftApplicationConnection",
      nextToken?: string | null,
    } | null,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    sunday?: boolean | null,
    suspended?: boolean | null,
    thursday?: boolean | null,
    timezone?: string | null,
    tuesday?: boolean | null,
    type?: AgendaUserType | null,
    updatedAt?: string | null,
    userId: string,
    username?: string | null,
    wednesday?: boolean | null,
  } | null,
};

export type HonoredByShiftQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaHonorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  shiftId: string,
  sortDirection?: ModelSortDirection | null,
};

export type HonoredByShiftQuery = {
  honoredByShift?:  {
    __typename: "ModelAgendaHonorConnection",
    items:  Array< {
      __typename: "AgendaHonor",
      createdAt?: string | null,
      deleted?: boolean | null,
      honorId: string,
      shiftId: string,
      type?: AgendaHonorType | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type HonoredByUserQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaHonorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type HonoredByUserQuery = {
  honoredByUser?:  {
    __typename: "ModelAgendaHonorConnection",
    items:  Array< {
      __typename: "AgendaHonor",
      createdAt?: string | null,
      deleted?: boolean | null,
      honorId: string,
      shiftId: string,
      type?: AgendaHonorType | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgendaCompaniesQueryVariables = {
  comId?: string | null,
  filter?: ModelAgendaCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgendaCompaniesQuery = {
  listAgendaCompanies?:  {
    __typename: "ModelAgendaCompanyConnection",
    items:  Array< {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgendaDocumentsQueryVariables = {
  docId?: string | null,
  filter?: ModelAgendaDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgendaDocumentsQuery = {
  listAgendaDocuments?:  {
    __typename: "ModelAgendaDocumentConnection",
    items:  Array< {
      __typename: "AgendaDocument",
      comId?: string | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      docId: string,
      name?: string | null,
      path?: string | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgendaHonorsQueryVariables = {
  filter?: ModelAgendaHonorFilterInput | null,
  honorId?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgendaHonorsQuery = {
  listAgendaHonors?:  {
    __typename: "ModelAgendaHonorConnection",
    items:  Array< {
      __typename: "AgendaHonor",
      createdAt?: string | null,
      deleted?: boolean | null,
      honorId: string,
      shiftId: string,
      type?: AgendaHonorType | null,
      updatedAt?: string | null,
      userId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgendaPostsQueryVariables = {
  filter?: ModelAgendaPostFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  postId?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgendaPostsQuery = {
  listAgendaPosts?:  {
    __typename: "ModelAgendaPostConnection",
    items:  Array< {
      __typename: "AgendaPost",
      comId: string,
      createdAt?: string | null,
      deleted?: boolean | null,
      description?: string | null,
      image?: string | null,
      postId: string,
      room?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgendaPunchesQueryVariables = {
  filter?: ModelAgendaPunchFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  punchId?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgendaPunchesQuery = {
  listAgendaPunches?:  {
    __typename: "ModelAgendaPunchConnection",
    items:  Array< {
      __typename: "AgendaPunch",
      accuracy?: string | null,
      altitude?: string | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      heading?: string | null,
      latitude?: string | null,
      longitude?: string | null,
      punchId: string,
      shiftId?: string | null,
      speed?: string | null,
      startAt?: string | null,
      stopAt?: string | null,
      timestamp?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgendaRequestsQueryVariables = {
  filter?: ModelAgendaRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  requestId?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgendaRequestsQuery = {
  listAgendaRequests?:  {
    __typename: "ModelAgendaRequestConnection",
    items:  Array< {
      __typename: "AgendaRequest",
      accepted?: boolean | null,
      comId?: string | null,
      completed?: boolean | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      description?: string | null,
      requestId: string,
      shiftId?: string | null,
      startAt?: string | null,
      stopAt?: string | null,
      suggestedUser?: string | null,
      suggestedUserImage?: string | null,
      suggestedUserUsername?: string | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgendaShiftApplicationsQueryVariables = {
  filter?: ModelAgendaShiftApplicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  shiftAppId?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgendaShiftApplicationsQuery = {
  listAgendaShiftApplications?:  {
    __typename: "ModelAgendaShiftApplicationConnection",
    items:  Array< {
      __typename: "AgendaShiftApplication",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      role?: string | null,
      shiftAppId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgendaShiftsQueryVariables = {
  filter?: ModelAgendaShiftFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  shiftId?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAgendaShiftsQuery = {
  listAgendaShifts?:  {
    __typename: "ModelAgendaShiftConnection",
    items:  Array< {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAgendaUsersQueryVariables = {
  filter?: ModelAgendaUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId?: string | null,
};

export type ListAgendaUsersQuery = {
  listAgendaUsers?:  {
    __typename: "ModelAgendaUserConnection",
    items:  Array< {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PostByRoomQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaPostFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  room: string,
  sortDirection?: ModelSortDirection | null,
};

export type PostByRoomQuery = {
  postByRoom?:  {
    __typename: "ModelAgendaPostConnection",
    items:  Array< {
      __typename: "AgendaPost",
      comId: string,
      createdAt?: string | null,
      deleted?: boolean | null,
      description?: string | null,
      image?: string | null,
      postId: string,
      room?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PostsByCompanyQueryVariables = {
  comId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaPostFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type PostsByCompanyQuery = {
  postsByCompany?:  {
    __typename: "ModelAgendaPostConnection",
    items:  Array< {
      __typename: "AgendaPost",
      comId: string,
      createdAt?: string | null,
      deleted?: boolean | null,
      description?: string | null,
      image?: string | null,
      postId: string,
      room?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PunchsByShiftQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaPunchFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  shiftId: string,
  sortDirection?: ModelSortDirection | null,
};

export type PunchsByShiftQuery = {
  punchsByShift?:  {
    __typename: "ModelAgendaPunchConnection",
    items:  Array< {
      __typename: "AgendaPunch",
      accuracy?: string | null,
      altitude?: string | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      heading?: string | null,
      latitude?: string | null,
      longitude?: string | null,
      punchId: string,
      shiftId?: string | null,
      speed?: string | null,
      startAt?: string | null,
      stopAt?: string | null,
      timestamp?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PunchsByUserQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaPunchFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type PunchsByUserQuery = {
  punchsByUser?:  {
    __typename: "ModelAgendaPunchConnection",
    items:  Array< {
      __typename: "AgendaPunch",
      accuracy?: string | null,
      altitude?: string | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      heading?: string | null,
      latitude?: string | null,
      longitude?: string | null,
      punchId: string,
      shiftId?: string | null,
      speed?: string | null,
      startAt?: string | null,
      stopAt?: string | null,
      timestamp?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RequestsByComIdQueryVariables = {
  comId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type RequestsByComIdQuery = {
  requestsByComId?:  {
    __typename: "ModelAgendaRequestConnection",
    items:  Array< {
      __typename: "AgendaRequest",
      accepted?: boolean | null,
      comId?: string | null,
      completed?: boolean | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      description?: string | null,
      requestId: string,
      shiftId?: string | null,
      startAt?: string | null,
      stopAt?: string | null,
      suggestedUser?: string | null,
      suggestedUserImage?: string | null,
      suggestedUserUsername?: string | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RequestsBySuggestedUserQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  suggestedUser: string,
};

export type RequestsBySuggestedUserQuery = {
  requestsBySuggestedUser?:  {
    __typename: "ModelAgendaRequestConnection",
    items:  Array< {
      __typename: "AgendaRequest",
      accepted?: boolean | null,
      comId?: string | null,
      completed?: boolean | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      description?: string | null,
      requestId: string,
      shiftId?: string | null,
      startAt?: string | null,
      stopAt?: string | null,
      suggestedUser?: string | null,
      suggestedUserImage?: string | null,
      suggestedUserUsername?: string | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RequestsByTypeQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  type: string,
};

export type RequestsByTypeQuery = {
  requestsByType?:  {
    __typename: "ModelAgendaRequestConnection",
    items:  Array< {
      __typename: "AgendaRequest",
      accepted?: boolean | null,
      comId?: string | null,
      completed?: boolean | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      description?: string | null,
      requestId: string,
      shiftId?: string | null,
      startAt?: string | null,
      stopAt?: string | null,
      suggestedUser?: string | null,
      suggestedUserImage?: string | null,
      suggestedUserUsername?: string | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RequestsByUserQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  userId: string,
};

export type RequestsByUserQuery = {
  requestsByUser?:  {
    __typename: "ModelAgendaRequestConnection",
    items:  Array< {
      __typename: "AgendaRequest",
      accepted?: boolean | null,
      comId?: string | null,
      completed?: boolean | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      description?: string | null,
      requestId: string,
      shiftId?: string | null,
      startAt?: string | null,
      stopAt?: string | null,
      suggestedUser?: string | null,
      suggestedUserImage?: string | null,
      suggestedUserUsername?: string | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ShiftAppsByComIdQueryVariables = {
  comId: string,
  filter?: ModelAgendaShiftApplicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  startAt?: ModelStringKeyConditionInput | null,
};

export type ShiftAppsByComIdQuery = {
  shiftAppsByComId?:  {
    __typename: "ModelAgendaShiftApplicationConnection",
    items:  Array< {
      __typename: "AgendaShiftApplication",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      role?: string | null,
      shiftAppId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ShiftAppsByLocQueryVariables = {
  filter?: ModelAgendaShiftApplicationFilterInput | null,
  limit?: number | null,
  location: string,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  startAt?: ModelStringKeyConditionInput | null,
};

export type ShiftAppsByLocQuery = {
  shiftAppsByLoc?:  {
    __typename: "ModelAgendaShiftApplicationConnection",
    items:  Array< {
      __typename: "AgendaShiftApplication",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      role?: string | null,
      shiftAppId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ShiftAppsByUserQueryVariables = {
  filter?: ModelAgendaShiftApplicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  startAt?: ModelStringKeyConditionInput | null,
  userId: string,
};

export type ShiftAppsByUserQuery = {
  shiftAppsByUser?:  {
    __typename: "ModelAgendaShiftApplicationConnection",
    items:  Array< {
      __typename: "AgendaShiftApplication",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      role?: string | null,
      shiftAppId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ShiftsByComIdQueryVariables = {
  comId: string,
  filter?: ModelAgendaShiftFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  startAt?: ModelStringKeyConditionInput | null,
};

export type ShiftsByComIdQuery = {
  shiftsByComId?:  {
    __typename: "ModelAgendaShiftConnection",
    items:  Array< {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ShiftsByShiftAppIdQueryVariables = {
  filter?: ModelAgendaShiftFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  shiftAppId: string,
  sortDirection?: ModelSortDirection | null,
  startAt?: ModelStringKeyConditionInput | null,
};

export type ShiftsByShiftAppIdQuery = {
  shiftsByShiftAppId?:  {
    __typename: "ModelAgendaShiftConnection",
    items:  Array< {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ShiftsByUserQueryVariables = {
  filter?: ModelAgendaShiftFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  startAt?: ModelStringKeyConditionInput | null,
  userId: string,
};

export type ShiftsByUserQuery = {
  shiftsByUser?:  {
    __typename: "ModelAgendaShiftConnection",
    items:  Array< {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByComIdQueryVariables = {
  comId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type UsersByComIdQuery = {
  usersByComId?:  {
    __typename: "ModelAgendaUserConnection",
    items:  Array< {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByUsernameQueryVariables = {
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelAgendaUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
  username: string,
};

export type UsersByUsernameQuery = {
  usersByUsername?:  {
    __typename: "ModelAgendaUserConnection",
    items:  Array< {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CreateAgendaCompanyMutationVariables = {
  condition?: ModelAgendaCompanyConditionInput | null,
  input: CreateAgendaCompanyInput,
};

export type CreateAgendaCompanyMutation = {
  createAgendaCompany?:  {
    __typename: "AgendaCompany",
    account_type?: string | null,
    address?: string | null,
    comId: string,
    createdAt?: string | null,
    customer_id?: string | null,
    image?: string | null,
    name?: string | null,
    phoneNumber?: string | null,
    planId?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    subscriptionId?: string | null,
    suspended?: boolean | null,
    type?: string | null,
    updatedAt?: string | null,
    userId?: string | null,
    users?:  {
      __typename: "ModelAgendaUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateAgendaDocumentMutationVariables = {
  condition?: ModelAgendaDocumentConditionInput | null,
  input: CreateAgendaDocumentInput,
};

export type CreateAgendaDocumentMutation = {
  createAgendaDocument?:  {
    __typename: "AgendaDocument",
    comId?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    docId: string,
    name?: string | null,
    path?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type CreateAgendaDocumentByUserIdMutationVariables = {
  comId?: string | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  docId: string,
  name?: string | null,
  path?: string | null,
  type?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type CreateAgendaDocumentByUserIdMutation = {
  createAgendaDocumentByUserId?:  {
    __typename: "AgendaDocument",
    comId?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    docId: string,
    name?: string | null,
    path?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type CreateAgendaHonorMutationVariables = {
  condition?: ModelAgendaHonorConditionInput | null,
  input: CreateAgendaHonorInput,
};

export type CreateAgendaHonorMutation = {
  createAgendaHonor?:  {
    __typename: "AgendaHonor",
    createdAt?: string | null,
    deleted?: boolean | null,
    honorId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId: string,
    type?: AgendaHonorType | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId: string,
  } | null,
};

export type CreateAgendaPostMutationVariables = {
  condition?: ModelAgendaPostConditionInput | null,
  input: CreateAgendaPostInput,
};

export type CreateAgendaPostMutation = {
  createAgendaPost?:  {
    __typename: "AgendaPost",
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId: string,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    image?: string | null,
    postId: string,
    room?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type CreateAgendaPostByComIdMutationVariables = {
  comId: string,
  createdAt?: string | null,
  deleted?: boolean | null,
  description?: string | null,
  image?: string | null,
  postId: string,
  room?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
  username?: string | null,
};

export type CreateAgendaPostByComIdMutation = {
  createAgendaPostByComId?:  {
    __typename: "AgendaPost",
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId: string,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    image?: string | null,
    postId: string,
    room?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type CreateAgendaPunchMutationVariables = {
  condition?: ModelAgendaPunchConditionInput | null,
  input: CreateAgendaPunchInput,
};

export type CreateAgendaPunchMutation = {
  createAgendaPunch?:  {
    __typename: "AgendaPunch",
    accuracy?: string | null,
    altitude?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    heading?: string | null,
    latitude?: string | null,
    longitude?: string | null,
    punchId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    speed?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    timestamp?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type CreateAgendaRequestMutationVariables = {
  condition?: ModelAgendaRequestConditionInput | null,
  input: CreateAgendaRequestInput,
};

export type CreateAgendaRequestMutation = {
  createAgendaRequest?:  {
    __typename: "AgendaRequest",
    accepted?: boolean | null,
    comId?: string | null,
    completed?: boolean | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    requestId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    suggestedUser?: string | null,
    suggestedUserImage?: string | null,
    suggestedUserUsername?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type CreateAgendaRequestByComIdMutationVariables = {
  accepted?: boolean | null,
  comId?: string | null,
  completed?: boolean | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  description?: string | null,
  requestId: string,
  shiftId?: string | null,
  startAt?: string | null,
  stopAt?: string | null,
  suggestedUser?: string | null,
  suggestedUserImage?: string | null,
  suggestedUserUsername?: string | null,
  type?: string | null,
  updatedAt?: string | null,
  userId?: string | null,
};

export type CreateAgendaRequestByComIdMutation = {
  createAgendaRequestByComId?:  {
    __typename: "AgendaRequest",
    accepted?: boolean | null,
    comId?: string | null,
    completed?: boolean | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    requestId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    suggestedUser?: string | null,
    suggestedUserImage?: string | null,
    suggestedUserUsername?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type CreateAgendaShiftMutationVariables = {
  condition?: ModelAgendaShiftConditionInput | null,
  input: CreateAgendaShiftInput,
};

export type CreateAgendaShiftMutation = {
  createAgendaShift?:  {
    __typename: "AgendaShift",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    performance?: string | null,
    punch?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    punctuality?: string | null,
    quality?: string | null,
    rate?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    shiftApp?:  {
      __typename: "AgendaShiftApplication",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      role?: string | null,
      shiftAppId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftAppId?: string | null,
    shiftId: string,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type CreateAgendaShiftApplicationMutationVariables = {
  condition?: ModelAgendaShiftApplicationConditionInput | null,
  input: CreateAgendaShiftApplicationInput,
};

export type CreateAgendaShiftApplicationMutation = {
  createAgendaShiftApplication?:  {
    __typename: "AgendaShiftApplication",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    role?: string | null,
    shiftAppId: string,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type CreateAgendaShiftApplicationByUserIdMutationVariables = {
  accepted?: boolean | null,
  comId?: string | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  info?: string | null,
  lat?: string | null,
  lng?: string | null,
  location?: string | null,
  role?: string | null,
  shiftAppId: string,
  startAt?: string | null,
  stopAt?: string | null,
  suspended?: boolean | null,
  updatedAt?: string | null,
  userId?: string | null,
  username?: string | null,
};

export type CreateAgendaShiftApplicationByUserIdMutation = {
  createAgendaShiftApplicationByUserId?:  {
    __typename: "AgendaShiftApplication",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    role?: string | null,
    shiftAppId: string,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type CreateAgendaShiftByUserIdMutationVariables = {
  accepted?: boolean | null,
  comId?: string | null,
  confirmed?: boolean | null,
  createdAt?: string | null,
  deleted?: boolean | null,
  info?: string | null,
  lat?: string | null,
  lng?: string | null,
  location?: string | null,
  performance?: string | null,
  punctuality?: string | null,
  quality?: string | null,
  rate?: string | null,
  role?: string | null,
  shiftAppId?: string | null,
  shiftId: string,
  startAt?: string | null,
  stopAt?: string | null,
  suspended?: boolean | null,
  updatedAt?: string | null,
  userId?: string | null,
  username?: string | null,
};

export type CreateAgendaShiftByUserIdMutation = {
  createAgendaShiftByUserId?:  {
    __typename: "AgendaShift",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    performance?: string | null,
    punch?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    punctuality?: string | null,
    quality?: string | null,
    rate?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    shiftApp?:  {
      __typename: "AgendaShiftApplication",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      role?: string | null,
      shiftAppId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftAppId?: string | null,
    shiftId: string,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type CreateAgendaUserMutationVariables = {
  condition?: ModelAgendaUserConditionInput | null,
  input: CreateAgendaUserInput,
};

export type CreateAgendaUserMutation = {
  createAgendaUser?:  {
    __typename: "AgendaUser",
    FCMtoken?: string | null,
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId?: string | null,
    createdAt?: string | null,
    docs?:  {
      __typename: "ModelAgendaDocumentConnection",
      nextToken?: string | null,
    } | null,
    email?: string | null,
    firstName?: string | null,
    friday?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    hours?: number | null,
    image?: string | null,
    isConfirmed?: boolean | null,
    language?: string | null,
    lastName?: string | null,
    monday?: boolean | null,
    night?: boolean | null,
    password?: string | null,
    phoneNumber?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    profileOwner?: string | null,
    punches?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    readedAt?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    saturday?: boolean | null,
    shiftApps?:  {
      __typename: "ModelAgendaShiftApplicationConnection",
      nextToken?: string | null,
    } | null,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    sunday?: boolean | null,
    suspended?: boolean | null,
    thursday?: boolean | null,
    timezone?: string | null,
    tuesday?: boolean | null,
    type?: AgendaUserType | null,
    updatedAt?: string | null,
    userId: string,
    username?: string | null,
    wednesday?: boolean | null,
  } | null,
};

export type DeleteAgendaCompanyMutationVariables = {
  condition?: ModelAgendaCompanyConditionInput | null,
  input: DeleteAgendaCompanyInput,
};

export type DeleteAgendaCompanyMutation = {
  deleteAgendaCompany?:  {
    __typename: "AgendaCompany",
    account_type?: string | null,
    address?: string | null,
    comId: string,
    createdAt?: string | null,
    customer_id?: string | null,
    image?: string | null,
    name?: string | null,
    phoneNumber?: string | null,
    planId?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    subscriptionId?: string | null,
    suspended?: boolean | null,
    type?: string | null,
    updatedAt?: string | null,
    userId?: string | null,
    users?:  {
      __typename: "ModelAgendaUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteAgendaDocumentMutationVariables = {
  condition?: ModelAgendaDocumentConditionInput | null,
  input: DeleteAgendaDocumentInput,
};

export type DeleteAgendaDocumentMutation = {
  deleteAgendaDocument?:  {
    __typename: "AgendaDocument",
    comId?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    docId: string,
    name?: string | null,
    path?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type DeleteAgendaHonorMutationVariables = {
  condition?: ModelAgendaHonorConditionInput | null,
  input: DeleteAgendaHonorInput,
};

export type DeleteAgendaHonorMutation = {
  deleteAgendaHonor?:  {
    __typename: "AgendaHonor",
    createdAt?: string | null,
    deleted?: boolean | null,
    honorId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId: string,
    type?: AgendaHonorType | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId: string,
  } | null,
};

export type DeleteAgendaPostMutationVariables = {
  condition?: ModelAgendaPostConditionInput | null,
  input: DeleteAgendaPostInput,
};

export type DeleteAgendaPostMutation = {
  deleteAgendaPost?:  {
    __typename: "AgendaPost",
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId: string,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    image?: string | null,
    postId: string,
    room?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type DeleteAgendaPunchMutationVariables = {
  condition?: ModelAgendaPunchConditionInput | null,
  input: DeleteAgendaPunchInput,
};

export type DeleteAgendaPunchMutation = {
  deleteAgendaPunch?:  {
    __typename: "AgendaPunch",
    accuracy?: string | null,
    altitude?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    heading?: string | null,
    latitude?: string | null,
    longitude?: string | null,
    punchId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    speed?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    timestamp?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type DeleteAgendaRequestMutationVariables = {
  condition?: ModelAgendaRequestConditionInput | null,
  input: DeleteAgendaRequestInput,
};

export type DeleteAgendaRequestMutation = {
  deleteAgendaRequest?:  {
    __typename: "AgendaRequest",
    accepted?: boolean | null,
    comId?: string | null,
    completed?: boolean | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    requestId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    suggestedUser?: string | null,
    suggestedUserImage?: string | null,
    suggestedUserUsername?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type DeleteAgendaShiftMutationVariables = {
  condition?: ModelAgendaShiftConditionInput | null,
  input: DeleteAgendaShiftInput,
};

export type DeleteAgendaShiftMutation = {
  deleteAgendaShift?:  {
    __typename: "AgendaShift",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    performance?: string | null,
    punch?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    punctuality?: string | null,
    quality?: string | null,
    rate?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    shiftApp?:  {
      __typename: "AgendaShiftApplication",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      role?: string | null,
      shiftAppId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftAppId?: string | null,
    shiftId: string,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type DeleteAgendaShiftApplicationMutationVariables = {
  condition?: ModelAgendaShiftApplicationConditionInput | null,
  input: DeleteAgendaShiftApplicationInput,
};

export type DeleteAgendaShiftApplicationMutation = {
  deleteAgendaShiftApplication?:  {
    __typename: "AgendaShiftApplication",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    role?: string | null,
    shiftAppId: string,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type DeleteAgendaUserMutationVariables = {
  condition?: ModelAgendaUserConditionInput | null,
  input: DeleteAgendaUserInput,
};

export type DeleteAgendaUserMutation = {
  deleteAgendaUser?:  {
    __typename: "AgendaUser",
    FCMtoken?: string | null,
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId?: string | null,
    createdAt?: string | null,
    docs?:  {
      __typename: "ModelAgendaDocumentConnection",
      nextToken?: string | null,
    } | null,
    email?: string | null,
    firstName?: string | null,
    friday?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    hours?: number | null,
    image?: string | null,
    isConfirmed?: boolean | null,
    language?: string | null,
    lastName?: string | null,
    monday?: boolean | null,
    night?: boolean | null,
    password?: string | null,
    phoneNumber?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    profileOwner?: string | null,
    punches?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    readedAt?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    saturday?: boolean | null,
    shiftApps?:  {
      __typename: "ModelAgendaShiftApplicationConnection",
      nextToken?: string | null,
    } | null,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    sunday?: boolean | null,
    suspended?: boolean | null,
    thursday?: boolean | null,
    timezone?: string | null,
    tuesday?: boolean | null,
    type?: AgendaUserType | null,
    updatedAt?: string | null,
    userId: string,
    username?: string | null,
    wednesday?: boolean | null,
  } | null,
};

export type UpdateAgendaCompanyMutationVariables = {
  condition?: ModelAgendaCompanyConditionInput | null,
  input: UpdateAgendaCompanyInput,
};

export type UpdateAgendaCompanyMutation = {
  updateAgendaCompany?:  {
    __typename: "AgendaCompany",
    account_type?: string | null,
    address?: string | null,
    comId: string,
    createdAt?: string | null,
    customer_id?: string | null,
    image?: string | null,
    name?: string | null,
    phoneNumber?: string | null,
    planId?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    subscriptionId?: string | null,
    suspended?: boolean | null,
    type?: string | null,
    updatedAt?: string | null,
    userId?: string | null,
    users?:  {
      __typename: "ModelAgendaUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateAgendaDocumentMutationVariables = {
  condition?: ModelAgendaDocumentConditionInput | null,
  input: UpdateAgendaDocumentInput,
};

export type UpdateAgendaDocumentMutation = {
  updateAgendaDocument?:  {
    __typename: "AgendaDocument",
    comId?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    docId: string,
    name?: string | null,
    path?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type UpdateAgendaHonorMutationVariables = {
  condition?: ModelAgendaHonorConditionInput | null,
  input: UpdateAgendaHonorInput,
};

export type UpdateAgendaHonorMutation = {
  updateAgendaHonor?:  {
    __typename: "AgendaHonor",
    createdAt?: string | null,
    deleted?: boolean | null,
    honorId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId: string,
    type?: AgendaHonorType | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId: string,
  } | null,
};

export type UpdateAgendaPostMutationVariables = {
  condition?: ModelAgendaPostConditionInput | null,
  input: UpdateAgendaPostInput,
};

export type UpdateAgendaPostMutation = {
  updateAgendaPost?:  {
    __typename: "AgendaPost",
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId: string,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    image?: string | null,
    postId: string,
    room?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type UpdateAgendaPunchMutationVariables = {
  condition?: ModelAgendaPunchConditionInput | null,
  input: UpdateAgendaPunchInput,
};

export type UpdateAgendaPunchMutation = {
  updateAgendaPunch?:  {
    __typename: "AgendaPunch",
    accuracy?: string | null,
    altitude?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    heading?: string | null,
    latitude?: string | null,
    longitude?: string | null,
    punchId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    speed?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    timestamp?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type UpdateAgendaRequestMutationVariables = {
  condition?: ModelAgendaRequestConditionInput | null,
  input: UpdateAgendaRequestInput,
};

export type UpdateAgendaRequestMutation = {
  updateAgendaRequest?:  {
    __typename: "AgendaRequest",
    accepted?: boolean | null,
    comId?: string | null,
    completed?: boolean | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    requestId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    suggestedUser?: string | null,
    suggestedUserImage?: string | null,
    suggestedUserUsername?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type UpdateAgendaShiftMutationVariables = {
  condition?: ModelAgendaShiftConditionInput | null,
  input: UpdateAgendaShiftInput,
};

export type UpdateAgendaShiftMutation = {
  updateAgendaShift?:  {
    __typename: "AgendaShift",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    performance?: string | null,
    punch?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    punctuality?: string | null,
    quality?: string | null,
    rate?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    shiftApp?:  {
      __typename: "AgendaShiftApplication",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      role?: string | null,
      shiftAppId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftAppId?: string | null,
    shiftId: string,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type UpdateAgendaShiftApplicationMutationVariables = {
  condition?: ModelAgendaShiftApplicationConditionInput | null,
  input: UpdateAgendaShiftApplicationInput,
};

export type UpdateAgendaShiftApplicationMutation = {
  updateAgendaShiftApplication?:  {
    __typename: "AgendaShiftApplication",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    role?: string | null,
    shiftAppId: string,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type UpdateAgendaUserMutationVariables = {
  condition?: ModelAgendaUserConditionInput | null,
  input: UpdateAgendaUserInput,
};

export type UpdateAgendaUserMutation = {
  updateAgendaUser?:  {
    __typename: "AgendaUser",
    FCMtoken?: string | null,
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId?: string | null,
    createdAt?: string | null,
    docs?:  {
      __typename: "ModelAgendaDocumentConnection",
      nextToken?: string | null,
    } | null,
    email?: string | null,
    firstName?: string | null,
    friday?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    hours?: number | null,
    image?: string | null,
    isConfirmed?: boolean | null,
    language?: string | null,
    lastName?: string | null,
    monday?: boolean | null,
    night?: boolean | null,
    password?: string | null,
    phoneNumber?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    profileOwner?: string | null,
    punches?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    readedAt?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    saturday?: boolean | null,
    shiftApps?:  {
      __typename: "ModelAgendaShiftApplicationConnection",
      nextToken?: string | null,
    } | null,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    sunday?: boolean | null,
    suspended?: boolean | null,
    thursday?: boolean | null,
    timezone?: string | null,
    tuesday?: boolean | null,
    type?: AgendaUserType | null,
    updatedAt?: string | null,
    userId: string,
    username?: string | null,
    wednesday?: boolean | null,
  } | null,
};

export type OnCreateAgendaCompanySubscriptionVariables = {
  filter?: ModelSubscriptionAgendaCompanyFilterInput | null,
};

export type OnCreateAgendaCompanySubscription = {
  onCreateAgendaCompany?:  {
    __typename: "AgendaCompany",
    account_type?: string | null,
    address?: string | null,
    comId: string,
    createdAt?: string | null,
    customer_id?: string | null,
    image?: string | null,
    name?: string | null,
    phoneNumber?: string | null,
    planId?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    subscriptionId?: string | null,
    suspended?: boolean | null,
    type?: string | null,
    updatedAt?: string | null,
    userId?: string | null,
    users?:  {
      __typename: "ModelAgendaUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateAgendaDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaDocumentFilterInput | null,
};

export type OnCreateAgendaDocumentSubscription = {
  onCreateAgendaDocument?:  {
    __typename: "AgendaDocument",
    comId?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    docId: string,
    name?: string | null,
    path?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type OnCreateAgendaDocumentByUserIdSubscriptionVariables = {
  userId?: string | null,
};

export type OnCreateAgendaDocumentByUserIdSubscription = {
  onCreateAgendaDocumentByUserId?:  {
    __typename: "AgendaDocument",
    comId?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    docId: string,
    name?: string | null,
    path?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type OnCreateAgendaHonorSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaHonorFilterInput | null,
};

export type OnCreateAgendaHonorSubscription = {
  onCreateAgendaHonor?:  {
    __typename: "AgendaHonor",
    createdAt?: string | null,
    deleted?: boolean | null,
    honorId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId: string,
    type?: AgendaHonorType | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId: string,
  } | null,
};

export type OnCreateAgendaPostSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaPostFilterInput | null,
};

export type OnCreateAgendaPostSubscription = {
  onCreateAgendaPost?:  {
    __typename: "AgendaPost",
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId: string,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    image?: string | null,
    postId: string,
    room?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type OnCreateAgendaPostByCompanyIdSubscriptionVariables = {
};

export type OnCreateAgendaPostByCompanyIdSubscription = {
  onCreateAgendaPostByCompanyId?:  {
    __typename: "AgendaPost",
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId: string,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    image?: string | null,
    postId: string,
    room?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type OnCreateAgendaPunchSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaPunchFilterInput | null,
};

export type OnCreateAgendaPunchSubscription = {
  onCreateAgendaPunch?:  {
    __typename: "AgendaPunch",
    accuracy?: string | null,
    altitude?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    heading?: string | null,
    latitude?: string | null,
    longitude?: string | null,
    punchId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    speed?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    timestamp?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type OnCreateAgendaRequestSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaRequestFilterInput | null,
};

export type OnCreateAgendaRequestSubscription = {
  onCreateAgendaRequest?:  {
    __typename: "AgendaRequest",
    accepted?: boolean | null,
    comId?: string | null,
    completed?: boolean | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    requestId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    suggestedUser?: string | null,
    suggestedUserImage?: string | null,
    suggestedUserUsername?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type OnCreateAgendaRequestByCompanyIdSubscriptionVariables = {
};

export type OnCreateAgendaRequestByCompanyIdSubscription = {
  onCreateAgendaRequestByCompanyId?:  {
    __typename: "AgendaRequest",
    accepted?: boolean | null,
    comId?: string | null,
    completed?: boolean | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    requestId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    suggestedUser?: string | null,
    suggestedUserImage?: string | null,
    suggestedUserUsername?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type OnCreateAgendaShiftSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaShiftFilterInput | null,
};

export type OnCreateAgendaShiftSubscription = {
  onCreateAgendaShift?:  {
    __typename: "AgendaShift",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    performance?: string | null,
    punch?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    punctuality?: string | null,
    quality?: string | null,
    rate?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    shiftApp?:  {
      __typename: "AgendaShiftApplication",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      role?: string | null,
      shiftAppId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftAppId?: string | null,
    shiftId: string,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type OnCreateAgendaShiftApplicationSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaShiftApplicationFilterInput | null,
};

export type OnCreateAgendaShiftApplicationSubscription = {
  onCreateAgendaShiftApplication?:  {
    __typename: "AgendaShiftApplication",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    role?: string | null,
    shiftAppId: string,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type OnCreateAgendaShiftApplicationByUserIdSubscriptionVariables = {
  userId?: string | null,
};

export type OnCreateAgendaShiftApplicationByUserIdSubscription = {
  onCreateAgendaShiftApplicationByUserId?:  {
    __typename: "AgendaShiftApplication",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    role?: string | null,
    shiftAppId: string,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type OnCreateAgendaShiftByUserIdSubscriptionVariables = {
  userId?: string | null,
};

export type OnCreateAgendaShiftByUserIdSubscription = {
  onCreateAgendaShiftByUserId?:  {
    __typename: "AgendaShift",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    performance?: string | null,
    punch?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    punctuality?: string | null,
    quality?: string | null,
    rate?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    shiftApp?:  {
      __typename: "AgendaShiftApplication",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      role?: string | null,
      shiftAppId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftAppId?: string | null,
    shiftId: string,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type OnCreateAgendaUserSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaUserFilterInput | null,
};

export type OnCreateAgendaUserSubscription = {
  onCreateAgendaUser?:  {
    __typename: "AgendaUser",
    FCMtoken?: string | null,
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId?: string | null,
    createdAt?: string | null,
    docs?:  {
      __typename: "ModelAgendaDocumentConnection",
      nextToken?: string | null,
    } | null,
    email?: string | null,
    firstName?: string | null,
    friday?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    hours?: number | null,
    image?: string | null,
    isConfirmed?: boolean | null,
    language?: string | null,
    lastName?: string | null,
    monday?: boolean | null,
    night?: boolean | null,
    password?: string | null,
    phoneNumber?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    profileOwner?: string | null,
    punches?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    readedAt?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    saturday?: boolean | null,
    shiftApps?:  {
      __typename: "ModelAgendaShiftApplicationConnection",
      nextToken?: string | null,
    } | null,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    sunday?: boolean | null,
    suspended?: boolean | null,
    thursday?: boolean | null,
    timezone?: string | null,
    tuesday?: boolean | null,
    type?: AgendaUserType | null,
    updatedAt?: string | null,
    userId: string,
    username?: string | null,
    wednesday?: boolean | null,
  } | null,
};

export type OnDeleteAgendaCompanySubscriptionVariables = {
  filter?: ModelSubscriptionAgendaCompanyFilterInput | null,
};

export type OnDeleteAgendaCompanySubscription = {
  onDeleteAgendaCompany?:  {
    __typename: "AgendaCompany",
    account_type?: string | null,
    address?: string | null,
    comId: string,
    createdAt?: string | null,
    customer_id?: string | null,
    image?: string | null,
    name?: string | null,
    phoneNumber?: string | null,
    planId?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    subscriptionId?: string | null,
    suspended?: boolean | null,
    type?: string | null,
    updatedAt?: string | null,
    userId?: string | null,
    users?:  {
      __typename: "ModelAgendaUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteAgendaDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaDocumentFilterInput | null,
};

export type OnDeleteAgendaDocumentSubscription = {
  onDeleteAgendaDocument?:  {
    __typename: "AgendaDocument",
    comId?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    docId: string,
    name?: string | null,
    path?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type OnDeleteAgendaHonorSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaHonorFilterInput | null,
};

export type OnDeleteAgendaHonorSubscription = {
  onDeleteAgendaHonor?:  {
    __typename: "AgendaHonor",
    createdAt?: string | null,
    deleted?: boolean | null,
    honorId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId: string,
    type?: AgendaHonorType | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId: string,
  } | null,
};

export type OnDeleteAgendaPostSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaPostFilterInput | null,
};

export type OnDeleteAgendaPostSubscription = {
  onDeleteAgendaPost?:  {
    __typename: "AgendaPost",
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId: string,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    image?: string | null,
    postId: string,
    room?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type OnDeleteAgendaPunchSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaPunchFilterInput | null,
};

export type OnDeleteAgendaPunchSubscription = {
  onDeleteAgendaPunch?:  {
    __typename: "AgendaPunch",
    accuracy?: string | null,
    altitude?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    heading?: string | null,
    latitude?: string | null,
    longitude?: string | null,
    punchId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    speed?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    timestamp?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type OnDeleteAgendaRequestSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaRequestFilterInput | null,
};

export type OnDeleteAgendaRequestSubscription = {
  onDeleteAgendaRequest?:  {
    __typename: "AgendaRequest",
    accepted?: boolean | null,
    comId?: string | null,
    completed?: boolean | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    requestId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    suggestedUser?: string | null,
    suggestedUserImage?: string | null,
    suggestedUserUsername?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type OnDeleteAgendaShiftSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaShiftFilterInput | null,
};

export type OnDeleteAgendaShiftSubscription = {
  onDeleteAgendaShift?:  {
    __typename: "AgendaShift",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    performance?: string | null,
    punch?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    punctuality?: string | null,
    quality?: string | null,
    rate?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    shiftApp?:  {
      __typename: "AgendaShiftApplication",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      role?: string | null,
      shiftAppId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftAppId?: string | null,
    shiftId: string,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type OnDeleteAgendaShiftApplicationSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaShiftApplicationFilterInput | null,
};

export type OnDeleteAgendaShiftApplicationSubscription = {
  onDeleteAgendaShiftApplication?:  {
    __typename: "AgendaShiftApplication",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    role?: string | null,
    shiftAppId: string,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type OnDeleteAgendaUserSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaUserFilterInput | null,
};

export type OnDeleteAgendaUserSubscription = {
  onDeleteAgendaUser?:  {
    __typename: "AgendaUser",
    FCMtoken?: string | null,
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId?: string | null,
    createdAt?: string | null,
    docs?:  {
      __typename: "ModelAgendaDocumentConnection",
      nextToken?: string | null,
    } | null,
    email?: string | null,
    firstName?: string | null,
    friday?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    hours?: number | null,
    image?: string | null,
    isConfirmed?: boolean | null,
    language?: string | null,
    lastName?: string | null,
    monday?: boolean | null,
    night?: boolean | null,
    password?: string | null,
    phoneNumber?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    profileOwner?: string | null,
    punches?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    readedAt?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    saturday?: boolean | null,
    shiftApps?:  {
      __typename: "ModelAgendaShiftApplicationConnection",
      nextToken?: string | null,
    } | null,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    sunday?: boolean | null,
    suspended?: boolean | null,
    thursday?: boolean | null,
    timezone?: string | null,
    tuesday?: boolean | null,
    type?: AgendaUserType | null,
    updatedAt?: string | null,
    userId: string,
    username?: string | null,
    wednesday?: boolean | null,
  } | null,
};

export type OnUpdateAgendaCompanySubscriptionVariables = {
  filter?: ModelSubscriptionAgendaCompanyFilterInput | null,
};

export type OnUpdateAgendaCompanySubscription = {
  onUpdateAgendaCompany?:  {
    __typename: "AgendaCompany",
    account_type?: string | null,
    address?: string | null,
    comId: string,
    createdAt?: string | null,
    customer_id?: string | null,
    image?: string | null,
    name?: string | null,
    phoneNumber?: string | null,
    planId?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    subscriptionId?: string | null,
    suspended?: boolean | null,
    type?: string | null,
    updatedAt?: string | null,
    userId?: string | null,
    users?:  {
      __typename: "ModelAgendaUserConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateAgendaDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaDocumentFilterInput | null,
};

export type OnUpdateAgendaDocumentSubscription = {
  onUpdateAgendaDocument?:  {
    __typename: "AgendaDocument",
    comId?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    docId: string,
    name?: string | null,
    path?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type OnUpdateAgendaHonorSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaHonorFilterInput | null,
};

export type OnUpdateAgendaHonorSubscription = {
  onUpdateAgendaHonor?:  {
    __typename: "AgendaHonor",
    createdAt?: string | null,
    deleted?: boolean | null,
    honorId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId: string,
    type?: AgendaHonorType | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId: string,
  } | null,
};

export type OnUpdateAgendaPostSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaPostFilterInput | null,
};

export type OnUpdateAgendaPostSubscription = {
  onUpdateAgendaPost?:  {
    __typename: "AgendaPost",
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId: string,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    image?: string | null,
    postId: string,
    room?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type OnUpdateAgendaPunchSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaPunchFilterInput | null,
};

export type OnUpdateAgendaPunchSubscription = {
  onUpdateAgendaPunch?:  {
    __typename: "AgendaPunch",
    accuracy?: string | null,
    altitude?: string | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    heading?: string | null,
    latitude?: string | null,
    longitude?: string | null,
    punchId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    speed?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    timestamp?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type OnUpdateAgendaRequestSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaRequestFilterInput | null,
};

export type OnUpdateAgendaRequestSubscription = {
  onUpdateAgendaRequest?:  {
    __typename: "AgendaRequest",
    accepted?: boolean | null,
    comId?: string | null,
    completed?: boolean | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    description?: string | null,
    requestId: string,
    shift?:  {
      __typename: "AgendaShift",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      performance?: string | null,
      punctuality?: string | null,
      quality?: string | null,
      rate?: string | null,
      role?: string | null,
      shiftAppId?: string | null,
      shiftId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftId?: string | null,
    startAt?: string | null,
    stopAt?: string | null,
    suggestedUser?: string | null,
    suggestedUserImage?: string | null,
    suggestedUserUsername?: string | null,
    type?: string | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
  } | null,
};

export type OnUpdateAgendaShiftSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaShiftFilterInput | null,
};

export type OnUpdateAgendaShiftSubscription = {
  onUpdateAgendaShift?:  {
    __typename: "AgendaShift",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    performance?: string | null,
    punch?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    punctuality?: string | null,
    quality?: string | null,
    rate?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    shiftApp?:  {
      __typename: "AgendaShiftApplication",
      accepted?: boolean | null,
      comId?: string | null,
      confirmed?: boolean | null,
      createdAt?: string | null,
      deleted?: boolean | null,
      info?: string | null,
      lat?: string | null,
      lng?: string | null,
      location?: string | null,
      role?: string | null,
      shiftAppId: string,
      startAt?: string | null,
      stopAt?: string | null,
      suspended?: boolean | null,
      updatedAt?: string | null,
      userId?: string | null,
      username?: string | null,
    } | null,
    shiftAppId?: string | null,
    shiftId: string,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type OnUpdateAgendaShiftApplicationSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaShiftApplicationFilterInput | null,
};

export type OnUpdateAgendaShiftApplicationSubscription = {
  onUpdateAgendaShiftApplication?:  {
    __typename: "AgendaShiftApplication",
    accepted?: boolean | null,
    comId?: string | null,
    confirmed?: boolean | null,
    createdAt?: string | null,
    deleted?: boolean | null,
    info?: string | null,
    lat?: string | null,
    lng?: string | null,
    location?: string | null,
    role?: string | null,
    shiftAppId: string,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    startAt?: string | null,
    stopAt?: string | null,
    suspended?: boolean | null,
    updatedAt?: string | null,
    user?:  {
      __typename: "AgendaUser",
      FCMtoken?: string | null,
      comId?: string | null,
      createdAt?: string | null,
      email?: string | null,
      firstName?: string | null,
      friday?: boolean | null,
      hours?: number | null,
      image?: string | null,
      isConfirmed?: boolean | null,
      language?: string | null,
      lastName?: string | null,
      monday?: boolean | null,
      night?: boolean | null,
      password?: string | null,
      phoneNumber?: string | null,
      profileOwner?: string | null,
      readedAt?: string | null,
      role?: string | null,
      saturday?: boolean | null,
      sunday?: boolean | null,
      suspended?: boolean | null,
      thursday?: boolean | null,
      timezone?: string | null,
      tuesday?: boolean | null,
      type?: AgendaUserType | null,
      updatedAt?: string | null,
      userId: string,
      username?: string | null,
      wednesday?: boolean | null,
    } | null,
    userId?: string | null,
    username?: string | null,
  } | null,
};

export type OnUpdateAgendaUserSubscriptionVariables = {
  filter?: ModelSubscriptionAgendaUserFilterInput | null,
};

export type OnUpdateAgendaUserSubscription = {
  onUpdateAgendaUser?:  {
    __typename: "AgendaUser",
    FCMtoken?: string | null,
    com?:  {
      __typename: "AgendaCompany",
      account_type?: string | null,
      address?: string | null,
      comId: string,
      createdAt?: string | null,
      customer_id?: string | null,
      image?: string | null,
      name?: string | null,
      phoneNumber?: string | null,
      planId?: string | null,
      subscriptionId?: string | null,
      suspended?: boolean | null,
      type?: string | null,
      updatedAt?: string | null,
      userId?: string | null,
    } | null,
    comId?: string | null,
    createdAt?: string | null,
    docs?:  {
      __typename: "ModelAgendaDocumentConnection",
      nextToken?: string | null,
    } | null,
    email?: string | null,
    firstName?: string | null,
    friday?: boolean | null,
    honors?:  {
      __typename: "ModelAgendaHonorConnection",
      nextToken?: string | null,
    } | null,
    hours?: number | null,
    image?: string | null,
    isConfirmed?: boolean | null,
    language?: string | null,
    lastName?: string | null,
    monday?: boolean | null,
    night?: boolean | null,
    password?: string | null,
    phoneNumber?: string | null,
    posts?:  {
      __typename: "ModelAgendaPostConnection",
      nextToken?: string | null,
    } | null,
    profileOwner?: string | null,
    punches?:  {
      __typename: "ModelAgendaPunchConnection",
      nextToken?: string | null,
    } | null,
    readedAt?: string | null,
    requests?:  {
      __typename: "ModelAgendaRequestConnection",
      nextToken?: string | null,
    } | null,
    role?: string | null,
    saturday?: boolean | null,
    shiftApps?:  {
      __typename: "ModelAgendaShiftApplicationConnection",
      nextToken?: string | null,
    } | null,
    shifts?:  {
      __typename: "ModelAgendaShiftConnection",
      nextToken?: string | null,
    } | null,
    sunday?: boolean | null,
    suspended?: boolean | null,
    thursday?: boolean | null,
    timezone?: string | null,
    tuesday?: boolean | null,
    type?: AgendaUserType | null,
    updatedAt?: string | null,
    userId: string,
    username?: string | null,
    wednesday?: boolean | null,
  } | null,
};
